import React from 'react'

import { Page, View, Text } from '@react-pdf/renderer'
import styles from '../style'

import TopBanner from '../Components/TopBanner'

const Bullet = ({ children }: { children: React.ReactNode }) => (
  <Text style={{ marginVertical: 1 }}>
    {'\u2022 '}
    {children}
    {'\n'}
  </Text>
)

const InfoSection = ({
  title,
  children
}: {
  title: string
  children: React.ReactNode
}) => (
  <View style={styles.section}>
    <Text style={styles.detailsSectionHeader}>{title}</Text>
    <Text style={styles.detailsSectionContent}>{children}</Text>
  </View>
)

type IDetailsPageProps = {
  pepmPayable?: number | null
}

const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 0
})

const DetailsPage = ({ pepmPayable }: IDetailsPageProps) => {
  return (
    <Page>
      <TopBanner title="Details" />
      <View style={styles.pageBody}>
        <InfoSection title="Plan Information">
          <Bullet>Funding Type: Level Funded</Bullet>
          <Bullet>Accumulation Period: Calendar Year</Bullet>
        </InfoSection>
        <InfoSection title="Eligibility Requirements">
          <Bullet>
            If enrollment differs by more than 10% during the contract year,
            Angle reserves the right to reevaluate rates and plan designs.
          </Bullet>
          <Bullet>
            The number of COBRA participants may not exceed 10% of the group
            enrollment.
          </Bullet>
          <Bullet>This quote assumes retirees will not be covered.</Bullet>
          <Bullet>
            Rates are based on your submitted census. We reserve the right to
            adjust the rates from audit date back to effective date if there are
            any material changes to enrollment.
          </Bullet>
        </InfoSection>
        <InfoSection title="Contribution Requirements">
          <Bullet>
            Employer contributes a minimum of 50% toward the employee only rates
            and toward the dependent rates.
          </Bullet>
          <Bullet>Requires a minimum participation level of 50%.</Bullet>
          <Bullet>
            Rates assume no deductible, coinsurance, or copays will be paid by
            the group (except as approved for HSA and HRA products).
          </Bullet>
        </InfoSection>
        <InfoSection title="Other Requirements">
          <Bullet>Angle Health is the only Medical Carrier</Bullet>
          <Bullet>
            This quote assumes the group has a current Workers Compensation plan
            in place.
          </Bullet>
          <Bullet>
            Additional fees may be required due to Federal Health Care Reform.
            PCORI Fees will be paid by the group.
          </Bullet>
          { pepmPayable && (
            <Bullet>
              This proposal includes a {currencyFormatter.format(pepmPayable)} PEPM compensation fee.
            </Bullet>
          ) }
        </InfoSection>
        <Text style={styles.detailsSectionContent}>
          Rates are guaranteed for the 12-month contract period only.
        </Text>
        <Text style={[styles.detailsSectionContent, { marginTop: 10 }]}>
          Angle Health reserves the right to withdraw or change the bid if any
          of the bid information changes, including but not limited to any
          claims, demographic or other changes what may affect the risk of the
          group.
        </Text>
      </View>
    </Page>
  )
}

export default DetailsPage
